import axios from 'axios'
import constants from '../constants'

const COLLECTION_PATH = `${constants.urlPrefix}/api/collections`;

const getForProduct = (product) => axios.get(`${COLLECTION_PATH}`, { params: { product } });

const remove = (id) => axios.delete(`${COLLECTION_PATH}/${id}`);

const save = (collections) => axios.post(`${COLLECTION_PATH}`, collections);

export default {
    save,
    remove,
    getForProduct
}
